module.exports = __webpack_public_path__ + "img/report-6.c930d0e2.jpg";